import {
    createAction,
    createSlice,
    type PayloadAction,
} from '@reduxjs/toolkit';

import type { RootState } from '../root/config.store';
import { NotificationDetails, NotificationGetPayload, NotificationReadStatusPayload, initialState} from '../../types/notifications';

// slice
export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        fetchAllisLoading(state) {
            state.loading = true;
        },
        fetchAllSucceeded(state, action: PayloadAction<NotificationDetails[]>) {
            state.data = action.payload;
            state.loading = false;
        },
        fetchAllFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.loading = false;
        },
        AddReadStatusRequest(state, action: PayloadAction<NotificationReadStatusPayload>){
            state.loading = true;
        },
        AddReadStatusSucceeded(state, action: PayloadAction<string>){
            state.loading = false;
        },
        AddReadStatusFailure(state, action: PayloadAction<string>){
             state.error = action.payload;
            state.loading = false;
        },
    },
});

// Actions
export const notificationActions = {
    fetchAll: createAction<NotificationGetPayload>(
        `${notificationSlice.name}/fetchAll`
      ),
    fetchAllisLoading: notificationSlice.actions.fetchAllisLoading,
    fetchAllSucceeded: notificationSlice.actions.fetchAllSucceeded,
    fetchAllFailure: notificationSlice.actions.fetchAllFailure,
    AddReadStatusRequest : notificationSlice.actions.AddReadStatusRequest,
    AddReadStatusSucceeded: notificationSlice.actions.AddReadStatusSucceeded,
    AddReadStatusFailure: notificationSlice.actions.AddReadStatusFailure
};

// Selectors
export const selectNotification = (state: RootState): NotificationDetails[] => state.notificationDetails?.data ?? [];
export const selectNotificationSaveMessage = (state: RootState): string => state ?? "";

// Reducer
export default notificationSlice.reducer;